




















import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';
import Signup from '@/components/common/Signup.vue';
import MainTitle from '@/components/common/MainTitle.vue';
import { SubjectBlock } from '@/views/Subjects.vue';
import { SubjectType } from '@/resource/subject/subject.model';

@Component({
  components: {
    Modal,
    Signup,
    MainTitle,
  },
})
export default class ModalSubject extends Vue {
  @Prop()
  showSubjectModal!: boolean;

  @Prop()
  closeSubjectModal!: () => void;

  @Prop()
  selectedSubject!: SubjectBlock;

  @Prop()
  selectedSubjectType!: SubjectType;

  @Prop()
  selectedSubjectlabel!: string;

  get subjectPath() {
    if (this.selectedSubject) {
      return this.selectedSubject.path;
    } else {
      return '';
    }
  }

  objTitle = [
    {
      type: 'highlight',
      value: 'Objective',
    },
    {
      type: 'normal',
      value: 'questions',
    },
  ];

  subjTitle = [
    {
      type: 'highlight',
      value: 'Subjective',
    },
    {
      type: 'normal',
      value: 'questions',
    },
  ];

  width = '600px';
  title = 'Choose question type';
  description = '';

  objectiveClick() {
    this.$router.push({
      path: `/subjects/${this.subjectPath}/${this.selectedSubjectType}`,
    });
  }

  subjectiveClick() {
    this.$router.push({
      path: `/subjects/${this.subjectPath}/${this.selectedSubjectType}?is-subjective=true`,
    });
  }
}
